'use strict';

export default class AddModelController {

  /*@ngInject*/
  constructor($http, $state, $stateParams) {
    this.$http = $http;
    this.$state = $state;
    this.$stateParams = $stateParams;
    this.list = [];
    this.one = {
      models: [],
    };
  }


  $onInit() {
    this.getList();
  }

  save() {
    this.$http.post(`/api/AppConfGroups/${this.$stateParams.id}/addModel`, this.one).then(res => {
      this.$state.go('appconfgroups.show', {id: this.$stateParams.id});
    });
  }
  getList(){
    this.$http.get('/api/groups/').then(response => {
      this.list = response.data;
    });
  }

  toggleSelection(id) {
    let idx = this.one.models.indexOf(id);
    if(idx > -1) {
      this.one.models.splice(idx, 1);
    } else {
      this.one.models.push(id);
    }
    console.log("----toggleSelection-----one---->", this.one);
    
  }
}



// WEBPACK FOOTER //
// ./client/app/appconfgroups/addmodel/addmodel.controller.js